
import { Button } from "@/components/ui/button";
import { MoreVertical, RefreshCw, Power } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import StatusBadge from "../StatusBadge";
import { Monitor } from "lucide-react";

interface DeviceCardHeaderProps {
  name: string;
  status: string;
  onCheckIn: () => void;
  onUnenroll: () => void;
}

const DeviceCardHeader = ({ name, status, onCheckIn, onUnenroll }: DeviceCardHeaderProps) => {
  return (
    <div className="flex justify-between items-start mb-4">
      <div className="flex items-center">
        <Monitor className="h-5 w-5 text-blue-700 mr-2" />
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white">{name}</h3>
      </div>
      <div className="flex items-center gap-2">
        <StatusBadge status={status} />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem onClick={onCheckIn}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Check In
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onUnenroll} className="text-red-600 focus:text-red-600">
              <Power className="mr-2 h-4 w-4" />
              Unenroll
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default DeviceCardHeader;
